export const THEME_STORAGE_KEY = "umbracoCmsBase.siteTheme";
export const DARK_SYSTEM_THEME_QUERY = "(prefers-color-scheme: dark)";

export function normalizeTheme(theme) {
  return String(theme).toLowerCase() === "dark" ? "dark" : "light";
}

export function getStoredTheme() {
  try {
    const storedTheme = window.localStorage.getItem(THEME_STORAGE_KEY);

    if (storedTheme === "dark" || storedTheme === "light") {
      return storedTheme;
    }
  } catch {
    return null;
  }

  return null;
}

export function storeTheme(theme) {
  try {
    window.localStorage.setItem(THEME_STORAGE_KEY, normalizeTheme(theme));
  } catch {
    // Ignore storage errors so private browsing or blocked storage never breaks the theme switch.
  }
}

export function matchesMediaQuery(query) {
  return window.matchMedia?.(query).matches ?? false;
}

export function getSystemTheme() {
  return matchesMediaQuery(DARK_SYSTEM_THEME_QUERY) ? "dark" : "light";
}

export function getInitialTheme() {
  const storedTheme = getStoredTheme();

  if (storedTheme) {
    return storedTheme;
  }

  return getSystemTheme();
}
